import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function deleteMunicipality(id) {
	return fetch(
		`${ENDPOINT_URL}/municipality/${id}/delete`,
		getFetchOptions({
			method: 'DELETE',
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
